<mat-dialog-content>
  <div>
    <h6>Selected file(s):</h6>
    <ul class="user-list">
      <li *ngFor="let elt of data">
        {{elt.file_name}}
      </li>
    </ul>
  </div>

  <div class="recipient-section" *ngIf="this.alreadySharedList.length > 0">
    <h6>Already shared with:</h6>
    <mat-chip-list>
      <mat-chip *ngFor="let user of alreadySharedList"
                [disabled]="user.deleted"
                [removable]="removable"
                (removed)="removeSharedAccess(user, alreadySharedList);
              updateEmailValidation(emailInput.value)">
        {{user.email}}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>

  <div class="recipient-section" *ngIf="this.alreadyDownloadList.length > 0">
    <h6>Already downloaded by:</h6>
    <mat-chip-list>
      <mat-chip *ngFor="let user of alreadyDownloadList"
                [disabled]="user.deleted"
                [removable]="removable"
                (removed)="removeSharedAccess(user, alreadyDownloadList);
               updateEmailValidation(emailInput.value)">
        {{user.email}}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>

  <div style="height: 24px"
       class="recipient-section"
       *ngIf="this.alreadyDownloadList.length > 0 || this.alreadySharedList.length > 0">
    <span class="mat-hint" *ngIf="deleteMessage" [@showAnimation]>{{deleteMessage}}</span>
  </div>

  <div class="recipient-section">
    <h6>Share with:</h6>
    <mat-form-field class="full-width">
      <mat-label>Emails:</mat-label>
      <mat-chip-list #chipList aria-label="Email selection">
        <mat-chip *ngFor="let email of userList"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="remove(email)">
          {{email}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
      <input placeholder="Ex. example@vallourec.com, example@gmail.com"
             type="email"
             name="recipient-email"
             autocomplete="off"
             autocapitalize="off"
             autocorrect="off"
             spellcheck="false"
             data-1p-ignore
             data-lpignore="true"
             data-bwignore
             data-form-type="other"
             matInput
             #emailInput
             (input)="updateEmailValidation(emailInput.value)"
             [matChipInputFor]="chipList"
             [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
             [matChipInputAddOnBlur]="addOnBlur"
             (matChipInputTokenEnd)="add($event)">
    </mat-form-field>
    <div class="mat-hint" *ngIf="!errorMessage">Press enter to validate the email</div>
    <div class="mat-error" *ngIf="errorMessage">
      {{errorMessage}}
    </div>
  </div>

  <div class="recipient-section">
    <h6>Message (Optional): </h6>
    <textarea id="recipientMessage"
              name="recipient-message"
              [formControl]="shareMessage"
              class="input"
              autocomplete="off"
              autocapitalize="off"
              autocorrect="off"
              spellcheck="false"
              data-1p-ignore
              data-lpignore="true"
              data-bwignore
              data-form-type="other">
    </textarea>
  </div>

  <div class="recipient-section" *ngIf="shareErrorMessage">
    <div class="mat-error" [@showAnimation]>{{shareErrorMessage}}</div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="cell-align-right">
  <button class="vlr-cta-btn vlr-icon-btn"
          (click)="share()"
          [disabled]="loading || userList.length == 0">
    <mat-icon>share</mat-icon>
    <span>Share file(s)</span>
  </button>

  <button class="vlr-secondary-btn vlr-icon-btn"
          (click)="onNoClick()">
    <mat-icon>close</mat-icon>
    <span>Close</span>
  </button>
</mat-dialog-actions>

